import { Link, usePage } from "@inertiajs/react"
import { LogOut, Settings } from "lucide-react"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { useMobileNavigation } from "@/hooks/use-mobile-navigation"
import { settingsProfilePath, signOutPath } from "@/routes"
import type { Auth, SharedData } from "@/types"

interface UserMenuContentProps {
  auth: Auth
}

export function UserMenuContent({ auth }: UserMenuContentProps) {
  const { user } = auth
  const cleanup = useMobileNavigation()
  const { csrf_token } = usePage<SharedData>().props

  return (
    <>
      <DropdownMenuLabel className="p-0 font-normal">
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <UserInfo user={user} showEmail={true} />
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem asChild>
          <Link
            className="block w-full"
            href={settingsProfilePath()}
            as="button"
            prefetch
            onClick={cleanup}
          >
            <Settings className="mr-2" />
            Settings
          </Link>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <form method="post" action={signOutPath()} className="w-full">
          <input type="hidden" name="_method" value="delete" />
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <button
            type="submit"
            className="flex w-full items-center px-2 py-1.5 text-sm"
            onClick={cleanup}
          >
            <LogOut className="mr-2 h-4 w-4" />
            Log out
          </button>
        </form>
      </DropdownMenuItem>
    </>
  )
}
